<template>
  <div class="category-maintanance">
    <div class="top">
      <a href="#/ApprovalIndex">
        <img src="../assets/images/adidas.png" style="width: 160px; height: 37px; margin-top: 10px" />
      </a>
      <a href="#/ApprovalIndex" style="margin-top: 10px; margin-left: 30px; float: left">
        <img src="../assets/icon/back2.png" />
      </a>
    </div>
    <div class="content_title">
      <div class="category-filter clearfix">
        <label style="color: #606266; font-size: 14px">X-PEX</label>
        <el-select v-model="xPEX" clearable placeholder="Please Choose" style="margin-left: 10px">
          <el-option v-for="item in xPEXS" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <label style="color: #606266; font-size: 14px">Sub X-PEX</label>
        <el-select
          v-model="SubXPEX"
          clearable
          placeholder="Please Choose"
          style="margin-left: 10px"
        >
          <el-option v-for="item in SubXPEXS" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-button class="button-search button-search-first" @click="search()">Search</el-button>
        <el-button class="button-search" @click="addCategory()">Add</el-button>
        <el-button class="button-search" @click="UpdateCategoryStatus('Active')">Enable</el-button>
        <el-button class="button-search" @click="UpdateCategoryStatus('Inactive')">Disable</el-button>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          v-loading="loading"
          :data="tableData"
          :header-cell-style="tableHeaderCell"
          :cell-style="tableCell"
          border
          fit
          @selection-change="handleSelectionChange"
        >
          <template>
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              :prop="item.value"
              :label="item.label"
              v-for="(item, index) in tableColumn"
              :key="index"
            >
              <template slot-scope="scope">
                <span v-if="item.value === 'vatRate'">{{TranslateValue(scope.row[item.value])}}</span>
                <span v-else>{{scope.row[item.value]}}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <CategoryMaintananceAddDialog :dialogVisible="dialogVisible" @closeDialog="closeDialog" />
    </div>
  </div>
</template>

<script>
import CategoryMaintananceAddDialog from "@/components/CategoryMaintananceAddDialog.vue";
export default {
  components: {
    CategoryMaintananceAddDialog
  },

  data() {
    return {
      xPEX: "",
      xPEXS: ["Capex", "Opex"],
      SubXPEX: "",
      SubXPEXS: ["Capex", "Opex", "Digital"],
      loading: false,
      tableColumn: [
        {
          label: "Category Name",
          value: "categoryName"
        },
        {
          label: "X-PEX",
          value: "xpex"
        },
        {
          label: "Sub X-PEX",
          value: "sub_XPEX"
        },
        {
          label: "Supporting Scheme",
          value: "supportingScheme"
        },
        {
          label: "VAT Rate",
          value: "vatRate"
        },
        {
          label: "Status",
          value: "status"
        }
      ],
      tableData: [],
      form: {
        StoreFormat: "",
        Supporting: "",
        Link: "",
        Format: "",
        LatestModifiedDate: "",
        LatestModifiedBy: "",
        FxMNQ: "",
        LocalFX: "",
        LED: "",
        LCD: "",
        OCS: "",
        GamingArea: "",
        Printer: "",
        Projector: "",
        Lighting: "",
        Flooring: "",
        LocalDesign: "",
        FacadeLighting: "",
        CeilingLighting: "",
        GlobalDesign: ""
      },
      dialogVisible: false,
      multipleSelection: []
    };
  },
  created() {
    this.BindData();
  },
  methods: {
    tableHeaderCell({ column }) {
      return "background: #FFEDD1;color: #5A5854;text-align: center;";
    },
    tableCell({ column }) {
      return "background: #FFFFFF;color: #5A5854;text-align: center;";
    },
    getWidth(column) {
      return 9 * column.length + 10 + "px";
    },
    addCategory() {
      this.dialogVisible = true;
    },
    search() {
      this.BindData();
    },
    closeDialog(v) {
      console.log(v, this.tableData);
      if (v) {
        this.tableData.push({ ...v });
      }
      // console.log(this.tableData,'2233')
      this.dialogVisible = false;
    },
    handleSelectionChange(val) {
      console.log(val, "12");
      this.multipleSelection = val;
    },
    BindData() {
      this.loading = true;
      this.$api
        .get("/CR/GetCrCategory", {
          XPEX: this.xPEX,
          Sub_XPEX: this.SubXPEX
        })
        .then(res => {
          if (res.data.status == true) {
            this.tableData = res.data.content;
            this.total = res.data.total;
          } else {
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message
              });
              return false;
            }
          }
          this.loading = false;
        });
    },
    TranslateValue(value) {
      if (!!value) {
        return `${value * 100}%`;
      } else {
        return "";
      }
    },
    UpdateCategoryStatus(type) {
      let approvalID = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        approvalID[i] = this.multipleSelection[i].categoryID;
      }
      if (!approvalID.length) {
        this.$message({
          type: "error",
          message: "至少选择一个"
        });
        return;
      }
      this.$api
        .post("/CR/UpdateCategoryStatus", {
          ids: approvalID.toString(),
          type:type
        })
        .then(res => {
          if (res.data.status) {
            this.$message({
              type: "success",
              message: res.data.content
            });
            this.BindData();
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            });
            return false;
          }
        });
    }
  },

  mounted() {}
};
</script>

<style scoped lang="scss">
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}
.category-filter {
  text-align: left;
  margin-left: 5%;
  margin-top: 10px;
}
.content_title {
  margin: 10px auto 0;
  width: 90%;
  text-align: left;
  .title {
    margin-top: 20px;
    margin-bottom: 5px;
    color: #606266;
  }
  .button-search {
    &.button-search-first {
      margin-left: 10px;
    }
    background-color: #e6a23c;
    border: 0px #e6a23c;
    color: #ffff;
  }
  .table {
    min-height: 200px;
    margin-top: 10px;
  }
}
.clearfix:after {
  content: "";
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}
.clearfix {
  zoom: 1;
}
</style>
<style lang="scss">
.editForm {
  .el-form-item__label {
    font-size: 13px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CategoryMaintanance.vue